/**
 * Adree Theme — Hero Slider
 * Lightweight vanilla-JS slider with auto-advance, dots, fade transition.
 */

function initSlider() {
  const slider = document.querySelector('.js-hero-slider');
  const track = slider ? slider.querySelector('.js-hero-track') : null;
  const dots = slider ? slider.querySelectorAll('.hero-slider__dot') : [];

  if (!slider || !track) {
    return;
  }

  const slides = Array.from(track.children);
  const slideCount = slides.length;
  let current = 0;
  let intervalId = null;
  const autoAdvanceMs = 7000;

  function goToSlide(index) {
    if (index < 0 || index >= slideCount || index === current) {
      return;
    }

    const prevSlide = slides[current];
    const nextSlide = slides[index];

    prevSlide.classList.remove('is-active');
    prevSlide.setAttribute('aria-hidden', 'true');

    nextSlide.classList.add('is-active');
    nextSlide.setAttribute('aria-hidden', 'false');

    // Pause videos on inactive slides, play on active
    slides.forEach((slide, i) => {
      const video = slide.querySelector('video');
      if (video) {
        if (i === index) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      }
    });

    // Update dots
    dots.forEach((dot, i) => {
      const isActive = i === index;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-selected', String(isActive));
    });

    current = index;
  }

  function nextSlide() {
    goToSlide((current + 1) % slideCount);
  }

  function startAuto() {
    if (intervalId) {
      clearInterval(intervalId);
    }
    intervalId = setInterval(nextSlide, autoAdvanceMs);
  }

  function stopAuto() {
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
  }

  // Dot controls
  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => {
      stopAuto();
      goToSlide(i);
      startAuto();
    });
  });

  // Pause auto-advance on hover/focus
  slider.addEventListener('mouseenter', stopAuto);
  slider.addEventListener('mouseleave', startAuto);

  // Start
  startAuto();
}

export { initSlider };
